import { StyleSheet, css } from 'aphrodite'
import type React from 'react'

interface CurrencyInputProps {
  value: string | number | undefined
  onChange: (value: string) => void
  placeholder?: string
  disabled?: boolean
  className?: string
}

const CurrencyInput: React.FC<CurrencyInputProps> = ({
  value,
  onChange,
  placeholder = '0.00',
  disabled = false,
  className,
}) => {
  return (
    <div className={css(styles.inputWrapper)}>
      <span className={css(styles.dollarSign)}>$</span>
      <input
        type="text"
        value={value || ''}
        onChange={(e) => onChange(e.target.value)}
        className={css(styles.input, className && styles.input)}
        disabled={disabled}
        placeholder={placeholder}
      />
    </div>
  )
}

const styles = StyleSheet.create({
  inputWrapper: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
  },
  dollarSign: {
    position: 'absolute',
    left: '12px',
    color: '#6B7280',
    fontSize: '14px',
    fontWeight: 500,
    pointerEvents: 'none',
  },
  input: {
    width: '100%',
    padding: '8px 12px',
    paddingLeft: '28px',
    border: '1px solid rgb(209, 213, 219)',
    borderRadius: '6px',
    fontSize: '14px',
  },
})

export default CurrencyInput
